import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc, {css} from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../../constants/typography';
import {DropdownBody} from '../../../../atoms/Dropdown/Dropdown';
import {IconName} from '../../../../atoms/Icon/IconName';
import {SortingOption} from '../../types/SortingOption';
import {DropdownContentWrapper, FilterDropdown} from '../FilterDropdown';

interface Props {
  label: string;
  displayIcon?: IconName;
  activeOptionId?: string;
  defaultOptionId?: string;
  dataTestId?: string;
  onSelect: (optionId: string) => void;
  options: Array<SortingOption>;
  onOpen?: () => void;
  onClose?: () => void;
  renderInPortal?: boolean;
}

export const FilterDropdownSelect: React.FC<Props> = ({
  label,
  displayIcon,
  activeOptionId,
  defaultOptionId,
  dataTestId = 'filterFlyoutList',
  onSelect,
  options,
  onOpen,
  onClose,
  renderInPortal,
}) => {
  const activeId = activeOptionId || defaultOptionId;
  const hasActiveSelection =
    activeOptionId && activeOptionId !== defaultOptionId;

  return (
    <StyledFilterDropdown
      dataTestId={`${dataTestId}_${hasActiveSelection ? 'active' : 'inactive'}`}
      label={label}
      displayIcon={displayIcon}
      activeCount={hasActiveSelection ? -1 : 0}
      filterContent={
        <>
          {options.map(option => (
            <SelectOption
              active={Boolean(activeId && option.id === activeId)}
              data-testid={`${dataTestId}-${option.id}`}
              key={`${dataTestId}-${option.id}`}
              onClick={() => onSelect(option.id)}
              role="option"
            >
              {option.label}
            </SelectOption>
          ))}
        </>
      }
      openerType="single-arrow"
      closeOnContentClick={true}
      padContent={false}
      onClose={onClose}
      onOpen={onOpen}
      renderInPortal={renderInPortal}
    />
  );
};

const StyledFilterDropdown = linariaStyled(FilterDropdown)`
  ${DropdownBody}, ${DropdownContentWrapper} {
    min-width: 130px;
    width: unset;
  }
`;

// Do NOT refactor this to use `option` instead of `div` as it causes issues on Safari
const SelectOption = sc.div<{active?: boolean}>`
  box-sizing: border-box;
  height: 32px;
  padding: 0 0.875rem;
  font-size: ${FONT_SIZES.px14};
  cursor: pointer;
  transition: 0.15s;
  display: flex;
  align-items: center;
  white-space: nowrap;

  ${({active}) =>
    active
      ? css`
          font-weight: ${FONT_WEIGHTS.bold};
          background: ${COLORS.Grey5};
        `
      : css`
          background: ${COLORS.White};
        `};

  &:hover {
    background: ${({active}) => (active ? COLORS.White : COLORS.Grey4)};
    border-color: ${({active}) => (active ? COLORS.Black : COLORS.Grey4)};
  }
`;
